<app-modal title="CUSTOMERS.NEW" [loading]="loading" (submitClicked)="submit()" [closeText]="'CANCEL'"
           [submitText]="'SAVE'">
  <app-customer-form [parentCustomerForDisplay]="parentCustomer ?? null"
                     (formGroupOutput)="onFormGroupReady($event)"></app-customer-form>
</app-modal>
